class Filters {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = document.body;
        self.trigger = self.elem.querySelector('[data-filters-panel-trigger]');
        self.panel = self.elem.querySelector('[data-filters-panel]');
        self.panelCloseBtn = self.elem.querySelector('[data-filters-panel-close]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.shareModal = document.querySelector('[data-share-modal]');
        self.form = document.querySelector('[data-filters-form]');
        self.filterBadges = self.elem.querySelectorAll('[data-filter-badge]');
    }

    init() {
        let self = this;

        self.trigger.addEventListener('click', evt => {
            self.open();
        });

        self.panelCloseBtn.addEventListener('click', evt => {
            self.close();
        });

        self.initFilterBadges();
    }

    open() {
        let self = this;

        // Show panel
        self.panel.classList.add('is-active');

        // Force a re-paint
        let reflow = self.panel.offsetHeight;

        // Show panel (slide it in)
        self.panel.classList.add('is-open');

        // Set aria-expanded attribute to true
        self.trigger.setAttribute('aria-expanded', true);

        // Disable scrolling on body
        self.body.classList.add('is-no-scroll');

        // Add event listeners
        self.addEventListeners();
    }

    close() {
        let self = this;

        // Hide panel
        self.panel.classList.remove('is-open');

        // Set aria-expanded attribute to false
        self.trigger.setAttribute('aria-expanded', false);

        // Function to remove is-active class from panel once slide transition is complete
        let func = function() {
            self.panel.classList.remove('is-active');

            // Set aria-expanded attribute to false
            self.elem.setAttribute('aria-expanded', false);

            // Enable scrolling on body
            self.body.classList.remove('is-no-scroll');

            // Remove event listeners
            self.removeEventListeners();

            // Stop listening for end of transition
            self.panel.removeEventListener('transitionend', func);
        }

        // Listen for end of slide transition
        self.panel.addEventListener('transitionend', func, false);
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on:
        // - the dropdown or its children
        // - the trigger or its children
        // - the share modal or its children
        if (evt.target !== self.panel && !self.panel.contains(evt.target)
            && evt.target !== self.trigger && !self.trigger.contains(evt.target)
            && evt.target !== self.shareModal && !self.shareModal.contains(evt.target)) {

            // Close the dropdown
            self.close();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }

    initFilterBadges() {
        let self = this;

        [...self.filterBadges].map(item => {
            let relatedInput = document.getElementById(item.getAttribute('data-related-input'));

            item.addEventListener('click', evt => {
                relatedInput.checked = false;

                self.form.submit();
            });
        });
    }
}

export default Filters;
